import { getPlanDisplay } from '../constants/planDisplayCatalog'

const PLAN_SLUG = {
  FREE: 'free',
  START_VERIFICADO: 'start',
  PRO_VERIFICADO: 'pro',
  CORPORATIVO: 'corporate'
}

const SECTION_I18N = {
  Workspace: 'upgrade.sections.workspace',
  'Agenda e visualização': 'upgrade.sections.agendaView',
  'Recursos de Task': 'upgrade.sections.taskFeatures',
  'Recursos de CRM': 'upgrade.sections.crmFeatures',
  'Recursos avançados (Pro e Corporativo)': 'upgrade.sections.proAdvanced',
  Contrato: 'upgrade.sections.contract',
  'Resumo (API)': 'upgrade.sections.apiSummary'
}

const LABEL_I18N = {
  'Workspaces de Task (como dono)': 'upgrade.features.taskWorkspaces',
  'Workspaces de CRM (como dono)': 'upgrade.features.crmWorkspaces',
  'Usuários por workspace': 'upgrade.features.usersPerWorkspace',
  Agenda: 'upgrade.features.agenda',
  KANBAN: 'upgrade.features.kanban',
  'História da Task': 'upgrade.features.taskHistory',
  'Informações da Task': 'upgrade.features.taskInfo',
  'Checklist da Task': 'upgrade.features.taskChecklist',
  'Anexos na Task': 'upgrade.features.taskAttachments',
  'Cor da Task': 'upgrade.features.taskColor',
  'Financeiro na Task': 'upgrade.features.taskFinance',
  'Processo da tarefa': 'upgrade.features.taskProcess',
  'Tags da tarefa': 'upgrade.features.taskTags',
  'Usuários atribuídos na Task': 'upgrade.features.taskAssignedUsers',
  'Controle de atividade da Task': 'upgrade.features.taskActivity',
  'Agendamento da Task': 'upgrade.features.taskScheduling',
  'Histórico (chat) da Task': 'upgrade.features.taskChatHistory',
  'Relatórios CRM': 'upgrade.features.crmReports',
  'Histórico (chat) do CRM': 'upgrade.features.crmChatHistory',
  'Informações de contato do CRM': 'upgrade.features.crmContactInfo',
  'Informações do negócio do CRM': 'upgrade.features.crmDealInfo',
  'Origem do lead no CRM': 'upgrade.features.crmLeadSource',
  'Cor do lead no CRM': 'upgrade.features.crmLeadColor',
  'Usuários atribuídos no CRM': 'upgrade.features.crmAssignedUsers',
  'Agendamento no CRM': 'upgrade.features.crmScheduling',
  'Tags no CRM': 'upgrade.features.crmTags',
  'Anexos e imagens no CRM': 'upgrade.features.crmAttachments',
  'Integração com WhatsApp no CRM': 'upgrade.features.crmWhatsapp',
  'Editar layout da Task (desktop/mobile)': 'upgrade.features.taskEditLayout',
  'Forms personalizados': 'upgrade.features.customForms',
  'Menu Preview no Kanban': 'upgrade.features.kanbanPreview',
  'Grupos de permissão no Kanban': 'upgrade.features.kanbanPermissions',
  'Detalhes comerciais': 'upgrade.features.commercialDetails',
  'Workspaces Task / CRM': 'upgrade.features.apiTaskCrm',
  'Membros por workspace': 'upgrade.features.apiMembers',
  'WhatsApp CRM': 'upgrade.features.apiWhatsapp',
  'Layout / Forms / Preview Kanban': 'upgrade.features.apiLayoutBundle'
}

function translateDetail(detail, t) {
  const raw = String(detail ?? '').trim()
  const lower = raw.toLowerCase()
  if (lower === 'sim') return t('upgrade.detail.yes')
  if (lower === 'não' || lower === 'nao') return t('upgrade.detail.no')
  if (raw === 'Sob medida') return t('upgrade.detail.custom')
  if (raw === 'Definidos em contrato') return t('upgrade.detail.contract')
  return raw
}

function translateText(value, map, t) {
  const key = map[value]
  return key ? t(key) : value
}

function localizeMetric(value, t) {
  if (value === 'Sob medida') return t('upgrade.detail.custom')
  return value
}

export function localizeFeatureRows(rows, t) {
  if (!rows?.length) return []
  return rows.map((row) => {
    if (row.section) {
      return { section: translateText(row.section, SECTION_I18N, t) }
    }
    const localized = {
      label: translateText(row.label, LABEL_I18N, t),
      detail: translateDetail(row.detail, t)
    }
    if (row.highlight) localized.highlight = row.highlight
    if (row.tagline) {
      localized.tagline = t('upgrade.features.whatsappTagline')
    }
    return localized
  })
}

export function getLocalizedPlanDisplay(codigo, t) {
  const base = getPlanDisplay(codigo)
  if (!base) return null

  const slug = PLAN_SLUG[codigo]
  const subtitle = slug ? t(`dashboard.plans.${slug}.subtitle`) : ''
  const heroMetrics = base.heroMetrics
    ? {
        taskWs: localizeMetric(base.heroMetrics.taskWs, t),
        crmWs: localizeMetric(base.heroMetrics.crmWs, t),
        usersWs: localizeMetric(base.heroMetrics.usersWs, t)
      }
    : null

  return {
    ...base,
    title: slug ? t(`dashboard.plans.${slug}.title`) : base.title,
    subtitle: subtitle || null,
    description: slug ? t(`upgrade.plans.${slug}.description`) : base.description,
    heroMetrics,
    featureRows: localizeFeatureRows(base.featureRows, t)
  }
}
